import type { CSSProperties, FC, ReactNode } from 'react'
import { createPortal } from 'react-dom'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { XCloseIcon } from '@/components/ui/icons'
import { Overlay } from '@/components/ui/overlay'
import { cn } from '@/helpers/utils'

interface ModalProps {
	children: ReactNode
	className?: string
	closeIconOffset?: 'sm' | 'md' | 'lg'
	onClose?: () => void
	onOverlayClick?: () => void
	showCloseButton?: boolean
	width?: CSSProperties['width']
}

const closeIconOffsetStyles = {
	sm: 'top-3 ltr:right-3 rtl:left-3',
	md: 'top-4 ltr:right-4 rtl:left-4',
	lg: 'top-6 ltr:right-6 rtl:left-6'
}

/**
 * @deprecated Use Dialog instead
 */
export const Modal: FC<ModalProps> = ({
	children,
	className,
	closeIconOffset = 'md',
	onClose,
	onOverlayClick,
	width
}) => {
	return createPortal(
		<>
			<Overlay onClick={onOverlayClick} />
			<div
				className={cn(
					'fixed top-1/2 left-1/2 z-(--z-modal) max-h-[calc(100%-24px)] max-w-[calc(100%-24px)] -translate-x-1/2 -translate-y-1/2 overflow-y-auto rounded-xl bg-neutral-white shadow-lg',
					className
				)}
				style={{
					width: typeof width === 'number' ? `${width}px` : width
				}}
			>
				{onClose && (
					<ButtonLegacy
						className={cn(
							'absolute',
							closeIconOffsetStyles[closeIconOffset]
						)}
						onClick={onClose}
						shape='square'
						size='lg'
						type='button'
						variant='tertiary'
					>
						<XCloseIcon />
					</ButtonLegacy>
				)}
				{children}
			</div>
		</>,
		document.body
	)
}

Modal.displayName = 'Modal'
